import { render, staticRenderFns } from "./medicalScience.vue?vue&type=template&id=4d78b908&scoped=true"
import script from "./medicalScience.vue?vue&type=script&lang=js"
export * from "./medicalScience.vue?vue&type=script&lang=js"
import style0 from "./medicalScience.vue?vue&type=style&index=0&id=4d78b908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d78b908",
  null
  
)

export default component.exports